var map = {
	"./banner-image-1.jpg": 7834,
	"./banner-image-2.jpg": 4085,
	"./banner-image-3.jpg": 6216,
	"./banner-image-4.jpg": 9659,
	"./banner-image-5.jpg": 1614,
	"./banner-image-6.jpg": 8729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;